import React from "react";
import "../styles/ManageCookies.css";

const ManageCookies = ({ onClose }) => {
  return (
    <div className="cookie-modal-overlay" onClick={onClose}>
      <div className="cookie-modal" onClick={(e) => e.stopPropagation()}>
        <h2>Gerenciar Preferências de Cookies</h2>
        <p>
          Usamos cookies para melhorar sua experiência. Você pode aceitar ou rejeitar conforme sua preferência.
          Consulte nossa <a href="/privacy-policy">Política de Privacidade</a>.
        </p>
        <div className="cookie-modal-buttons">
          <button
            className="accept"
            onClick={() => {
              localStorage.setItem("cookieConsent", "accepted");
              onClose();
            }}
          >
            Aceitar
          </button>
          <button
            className="reject"
            onClick={() => {
              localStorage.setItem("cookieConsent", "rejected");
              onClose();
            }}
          >
            Rejeitar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ManageCookies;
